'use strict';

module.exports = Object.freeze([
  'Ok to sell my data',
]);
